import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementPostsMissingMetricsForReport.graphql';
import { Query, QueryengagementPostsMissingMetricsForReportArgs } from '../../__generated__/globalTypes';

export const useEngagementPostsMissingMetricsForReportQuery = (
  options?: QueryHookOptions<Query, QueryengagementPostsMissingMetricsForReportArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementPostsMissingMetricsForReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementPostsMissingMetricsForReportLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementPostsMissingMetricsForReportArgs>
): QueryResult<Query, QueryengagementPostsMissingMetricsForReportArgs> & {
  getEngagementPostsMissingMetricsForReport: LazyQueryExecFunction<
    Query,
    QueryengagementPostsMissingMetricsForReportArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementPostsMissingMetricsForReport, result] = useLazyQuery<
    Query,
    QueryengagementPostsMissingMetricsForReportArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementPostsMissingMetricsForReport, ...result };
};

export const useEngagementPostsMissingMetricsForReportPromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementPostsMissingMetricsForReport = useCallback(
    (options?: Omit<QueryOptions<QueryengagementPostsMissingMetricsForReportArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementPostsMissingMetricsForReportArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementPostsMissingMetricsForReport };
};
// Suspense Query Hooks
export const useEngagementPostsMissingMetricsForReportSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementPostsMissingMetricsForReportArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementPostsMissingMetricsForReportArgs>(QUERY, {
    ...options
  });

  return result;
};
